export type DisplayPrefs = {
  density: "roomy" | "compact";
  finePrint: boolean;
  sources: boolean;
  cashback: boolean;
  comparison: boolean;
};

const KEY = "azure-rate-check-prefs";

export const defaultPrefs: DisplayPrefs = {
  density: "roomy",
  finePrint: true,
  sources: true,
  cashback: true,
  comparison: true,
};

export function loadPrefs(): DisplayPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultPrefs;
    const parsed = JSON.parse(raw) as Partial<DisplayPrefs>;
    return { ...defaultPrefs, ...parsed };
  } catch {
    return defaultPrefs;
  }
}

export function savePrefs(prefs: DisplayPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    /* private mode */
  }
}
